import React, { FC, useCallback, useState } from 'react'
import styles from 'styles/components/list.module.scss'
import { Accordion, AccordionItem } from 'components/Accordion'
import { useToggleBoolean } from 'hooks/form'
import format from 'date-fns/format'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

type Props = {
  months: Date[]
  year: number
}

const MonthlyReportListItem: FC<Props> = React.memo((props) => {
  const { months, year } = props
  const dispatch = useDispatch()
  const [isExpanded, setExpanded] = useState<boolean>(false)
  const toggleExpanded = useToggleBoolean(setExpanded)
  const goToReportPage = useCallback((month: Date) => {
    dispatch(push(`/account/revenue/monthly_report/${format(month, 'yyyyMM')}`))
  }, [])

  return (
    <Accordion handleExpand={toggleExpanded} isExpand={isExpanded} label={`${year}年`}>
      <AccordionItem>
        <ul className={styles.monthlyReport__list}>
          {months.map((month) => (
            <li key={month.getMonth()} className={styles.monthlyReport__list__item}>
              <span>{format(month, 'yyyy年M月売上レポート')}</span>
              <a className={styles.monthlyReport__link} onClick={() => goToReportPage(month)} role={'button'}>
                確認する
              </a>
            </li>
          ))}
        </ul>
      </AccordionItem>
    </Accordion>
  )
})

export default MonthlyReportListItem
